import { generatePath } from "react-router-dom";
import CollectionLink from "./CollectionLink";

export default class PillarMerchantCollectionLink extends CollectionLink {
  constructor(merchantId, name, icon, path, authenticationName, pillarMerchantId, subLinks) {
    super(merchantId, name, icon, path, authenticationName, subLinks);
    this.pillarMerchantId = pillarMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, pillarMerchantId: this.pillarMerchantId });
  }
}
